import { render } from "./WordsEditor.vue?vue&type=template&id=db29dacc&scoped=true&ts=true"
import script from "./WordsEditor.vue?vue&type=script&lang=ts"
export * from "./WordsEditor.vue?vue&type=script&lang=ts"

import "./WordsEditor.vue?vue&type=style&index=0&id=db29dacc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db29dacc"]])

export default __exports__